var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.reseted)?_c('div',{staticClass:"video-player"},[_c('video',{ref:"video",staticClass:"video-js",attrs:{"x5-video-player-type":"h5","webkit-playsinline":"true","x5-video-orientation":"h5"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }